export interface WorkingHoursByRangeSummary {
  //Count = small + med  + large
  count: number;
  //Date = date, or start of week
  date: string;
  // count of people with working hours in the range
  lower: number; // # of people with working hours <= LOWER_BOUNDARY
  middle: number; // " " <= MIDDLE_BOUNDARY
  upper: number; // " " >= UPPER_BOUNDARY
}

export interface WorkingHoursByRangeDistributionResponseDto {
  data: WorkingHoursByRangeSummary[];
}
